import React from "react";
import "../SmcLife/IndexLife.css";
import WomenLife from "../SmcLife/Images/women-term.png"
import IconFeather from "../SmcLife/Images/Icon feather-trending-down.png"
import hdfc from "../SmcLife/Images/HDFC_Life_Logo.png";
import TataAia from "../SmcLife/Images/TATA-AIA-Logo.png";
const WomenTermLife = () => {
    return (

        <div className="col-lg-7">
            <h4 className="Index-Plan">
                Preserving Her <span className="textcolor">Legacy</span>: Women's Insurance Matters
            </h4>
            <p className="Index-Plan-Cont">
                Empowering women for financial security and peace of mind
            </p>
            <div className="Added_PicTaxBenefitBox">
                <div className="row">
                    <div className="col-md-6">
                        <div className="Family_lifesec women_life">
                            <div>
                                <img src={WomenLife} className="imgtop m-auto" alt="Life Plan Image" />
                            </div>
                            <div className="TaxBenefits TaxBenefits2">
                                <div className="GetLifeCNT GetLifeCNT2">
                                    <div className="">
                                        <img
                                            src={IconFeather}
                                            alt="Life Plan Image"
                                        />
                                    </div>
                                    <p>Pay up to <strong>28% less</strong> on the premiums</p>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="col-md-6 p-0">
                        <ul className="partners_img alliances_logo">
                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img
                                        src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                        className="aegon_life"
                                    />
                                </span>
                            </li>
                            <li className="partner_logo">
                                <span>
                                    <img src={hdfc} className="hdfc_life" />
                                </span>
                            </li>

                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img src={TataAia} className="tata_aia" />
                                </span>
                            </li>

                            <li className="Add_more">
                                <span>+many more</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WomenTermLife;
